import { render, staticRenderFns } from "./peaCRI.vue?vue&type=template&id=234d9412&scoped=true"
import script from "./peaCRI.vue?vue&type=script&lang=js"
export * from "./peaCRI.vue?vue&type=script&lang=js"
import style0 from "./peaCRI.vue?vue&type=style&index=0&id=234d9412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234d9412",
  null
  
)

export default component.exports